import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'
import { uploadPlaceDocuments, removePlaceDocument, downloadPlaceDocument } from '../../../api'

import UploadIcon from '../../Icons/UploadIcon'
import DocumentIcon from '../../Icons/DocumentIcon'
import DocumentItem from '../DocumentItem'
import ConfirmationModal from '../../Core/Dialog/ConfirmationModal'

const UploadDocuments = ({canManage, documents: storedDocuments, companyId, placeId, folderId, onUploaded, onRemove}) => {
  const { t } = useTranslation()

  const fileInputRef = useRef(null)
  const confirmationModalRef = useRef(null)

  const [uploadingDocuments, setUploadingDocuments] = useState([])

  const documents = [...uploadingDocuments, ...storedDocuments]

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const handleUpload = (event) => {
    const files = [...event.target.files]
    setUploadingDocuments(files.map(f => {
      return {
        original_name: f.name,
        size: f.size,
        original_mime_type: f.type,
        created_at: new Date(),
        uploading: true
      }
    }))
    uploadPlaceDocuments(companyId, placeId, folderId, files, uploadProgress).then(async res => {
      if (res) {
        await onUploaded()
        setUploadingDocuments([])
      }
    })
  }

  const handleRemoveDocument = async (documentId) => {
    const result = await confirmationModalRef.current.show({
      title: t('Are you sure to delete this file?'),
    })
    if (!result.success) {
      return
    }
    const res = await removePlaceDocument(companyId, placeId, folderId, documentId)
    if (res) {
      onRemove(documentId)
    }
  }

  const uploadProgress = (totalFilesSize, totalLoaded) => {
    setUploadingDocuments(prev => prev.map(doc => {
      if (doc.uploading) {
        const percentComplete = Math.round((totalLoaded / totalFilesSize) * 100)
        const progress = doc.size * (percentComplete / 100)
        return {...doc, progress: progress}
      }
      return doc
    }))
  }

  const handleDownload = async (documentId) => {
    downloadPlaceDocument(companyId, placeId, folderId, documentId)
  }

  return (
    <div className={styles.container}>
      {
        canManage
          ? <div className={styles.uploadButton} onClick={handleUploadClick}>
              <input
                ref={fileInputRef}
                type="file"
                id="fileUpload"
                style={{display: 'none'}}
                onChange={handleUpload}
                multiple />
              <UploadIcon />
              <div className={styles.uploadButtonTitle}>{t('Upload')}</div>
            </div>
          : null
      }
      <div className={styles.documentsSection}>
        <div className={styles.sectionTitle}>{t('Documents')}</div>
        <div className={styles.documentsList}>
          {
            documents.length
              ? documents.map((doc, i, array) => {
                  return(
                    <DocumentItem
                      key={i}
                      isLast={i === array.length - 1}
                      canManage={canManage}
                      document={doc}
                      onRemove={handleRemoveDocument}
                      onDownload={handleDownload} />
                  )
                })
              : <div className={styles.emptyContainer}>
                  <DocumentIcon />
                  {t('No documents uploaded yet')}
                </div>
          }
        </div>
      </div>
      <ConfirmationModal ref={confirmationModalRef} />
    </div>
  )
}

export default UploadDocuments